module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "campaign-recommendation",
    class: _vm.$style.root
  }, [_c('b-modal', {
    ref: "campaignRecomendationModal",
    staticClass: "campaign-recommendation",
    attrs: {
      "size": "lg",
      "hide-header": true,
      "hide-footer": true,
      "no-close-on-esc": true,
      "no-close-on-backdrop": true
    },
    on: {
      "hide": function($event) {
        _vm.start()
      }
    }
  }, [(_vm.loading) ? _c('loading') : [_c('h3', {
    staticClass: "text-center mb-3"
  }, [_vm._v(_vm._s(_vm.$t('pos.campaign-recommendation.title')))]), _c('div', {
    staticClass: "category-header-info"
  }, [_c('div', {
    staticClass: "category-selector mb-6"
  }, [_c('div', [(!_vm.dropdownOptions.length) ? _c('b-input-group', {
    staticClass: "business-category-autocomplete"
  }, [_c('b-button', {
    staticClass: "btn-target",
    attrs: {
      "slot": "left"
    },
    slot: "left"
  }, [_vm._v(_vm._s(_vm.$t('pos.campaign-recommendation.category')))]), _c('v-autocomplete', {
    directives: [{
      name: "autocomplete-extend",
      rawName: "v-autocomplete-extend"
    }],
    ref: "autocomplete",
    staticClass: "input-autocomplete",
    attrs: {
      "input-class": "form-control",
      "min-len": _vm.minLength,
      "wait": _vm.debounce,
      "items": _vm.categoryItems,
      "auto-select-one-item": false,
      "get-label": _vm.getCategoryLabel,
      "component-item": _vm.itemTemplate
    },
    on: {
      "update-items": _vm.onUpdateCategoryItems,
      "change": _vm.onChangeCategory
    },
    model: {
      value: (_vm.selectedCategory),
      callback: function($$v) {
        _vm.selectedCategory = $$v
      },
      expression: "selectedCategory"
    }
  }), _c('label', {
    staticClass: "control-label",
    on: {
      "click": _vm.clearCategoryAutocomplete
    }
  }, [(_vm.categoryLoading) ? _c('icon', {
    attrs: {
      "name": "spinner",
      "spin": "spin"
    }
  }) : (_vm.selectedCategory) ? _c('icon', {
    attrs: {
      "name": "close"
    }
  }) : _c('icon', {
    staticClass: "hidden",
    attrs: {
      "name": "close"
    }
  })], 1)], 1) : _vm._e(), (_vm.dropdownOptions.length) ? _c('b-input-group', {
    staticClass: "business-category-autocomplete"
  }, [(!_vm.selectedCategory) ? _c('b-button', {
    staticClass: "btn-target",
    attrs: {
      "slot": "left"
    },
    slot: "left"
  }, [_vm._v(_vm._s(_vm.$t('pos.campaign-recommendation.category')))]) : _vm._e(), _c('b-form-select', {
    ref: "dropdownCategory",
    staticClass: "business-objective",
    attrs: {
      "options": _vm.dropdownOptions,
      "text-field": "name",
      "size": "md"
    },
    on: {
      "input": _vm.loadSuggestedGoalType,
      "change": _vm.onChangeCategory
    },
    model: {
      value: (_vm.selectedCategory),
      callback: function($$v) {
        _vm.selectedCategory = $$v
      },
      expression: "selectedCategory"
    }
  })], 1) : _vm._e()], 1)]), (_vm.customerRemoteId) ? _c('div', {
    staticClass: "customer-remote-id mb-2"
  }, [_c('b-input-group', {
    staticClass: "customer-id"
  }, [_c('b-button', {
    staticClass: "btn-target",
    attrs: {
      "slot": "left"
    },
    slot: "left"
  }, [_vm._v(_vm._s(_vm.$t('pos.campaign-recommendation.customer_id')))]), _c('b-form-input', {
    staticClass: "form-control",
    attrs: {
      "value": _vm.customerRemoteId,
      "readonly": true
    }
  })], 1)], 1) : _vm._e()]), (_vm.visibleMarketingGoals.length) ? _c('div', {
    staticClass: "marketing-goals mt-4"
  }, [_c('h4', {
    staticClass: "mb-4"
  }, [_vm._v(_vm._s(_vm.$t('pos.campaign-recommendation.marketing-goal-title')))]), _c('div', {
    staticClass: "centered-block"
  }, _vm._l((_vm.visibleMarketingGoals), function(goal) {
    return _c('div', {
      staticClass: "block-option mb-2",
      attrs: {
        "data-marketing-goal-type": goal.name
      }
    }, [_c('div', {
      staticClass: "marketing-goal",
      class: (_vm.selectedMarketingGoal && _vm.selectedMarketingGoal.name === goal.name) ? 'selected' : '',
      on: {
        "click": function($event) {
          _vm.updateMarketingGoal(goal)
        }
      }
    }, [(goal.icon) ? _c('div', {
      staticClass: "goal-type-icon"
    }, [_c('img', {
      attrs: {
        "src": goal.icon
      }
    })]) : _vm._e(), _c('div', {
      staticClass: "goal-info"
    }, [_c('div', {
      staticClass: "goal-name h4"
    }, [_vm._v(_vm._s(_vm.$t('fn.complex.marketing_goal_name', {
      slug: goal.slug
    })))]), _c('markdown', {
      staticClass: "goal-desc",
      attrs: {
        "source": _vm.$t('fn.complex.marketing_goal_description', {
          slug: goal.slug
        })
      }
    })], 1)])])
  }))]) : _vm._e(), (_vm.suggestedGoalLoading || _vm.suggestedGoal) ? _c('div', {
    staticClass: "goal-selector mt-4"
  }, [(_vm.suggestedGoalLoading) ? _c('div', {
    staticClass: "text-center"
  }, [_c('icon', {
    attrs: {
      "name": "spinner",
      "spin": "spin",
      "scale": "2"
    }
  })], 1) : (_vm.suggestedGoal && _vm.displayOtherGoals === false) ? _c('div', {
    staticClass: "suggested-goals"
  }, [_c('h4', {
    staticClass: "mb-3"
  }, [_vm._v(_vm._s(_vm.$t('pos.campaign-recommendation.suggested-goal-title')))]), _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-sm-4 text-center goal-type-info"
  }, [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-xs-4 text-right"
  }, [(_vm.suggestedGoal.label_icon) ? _c('div', {
    staticClass: "goal-type-icon"
  }, [_c('img', {
    attrs: {
      "src": _vm.suggestedGoal.label_icon
    }
  })]) : _vm._e()]), _c('div', {
    staticClass: "col-xs-8 text-left larger"
  }, [_vm._v(_vm._s(_vm.$t(("pos.setup.optimize-for." + (_vm.suggestedGoal.goal_type)))))])])]), _c('div', {
    staticClass: "col-sm-4 ideal-for-info"
  }, [_c('h5', {
    staticClass: "mt-2"
  }, [_vm._v(_vm._s(_vm.$t('pos.campaign-recommendation.suggested-goal-ideal-for')))]), _c('markdown', {
    attrs: {
      "source": _vm.$t('fn.complex.campaign_goal_ideal_for', {
        goal_type: _vm.suggestedGoal.goal_type
      })
    }
  })], 1), _c('div', {
    staticClass: "col-sm-4 text-center"
  }, [_c('div', [(_vm.displayNotificationFor === _vm.suggestedGoal.goal_type) ? _c('div', {
    staticClass: "box goal-type-notice"
  }, [_c('div', {
    staticClass: "content-box"
  }, [_c('div', {
    staticClass: "text",
    domProps: {
      "innerHTML": _vm._s(_vm.getGoalTypeNotice(_vm.suggestedGoal.goal_type))
    }
  }), _c('div', {
    staticClass: "options"
  }, [_c('b-button', {
    staticClass: "btn-ok",
    attrs: {
      "size": "sm"
    },
    on: {
      "click": function($event) {
        _vm.updateGoalType(_vm.suggestedGoal.goal_type)
      }
    }
  }, [_vm._v(_vm._s(_vm.$t('terms.misc.proceed')))]), _c('b-button', {
    attrs: {
      "variant": "cancel",
      "size": "sm"
    },
    on: {
      "click": _vm.hideGoalTypeNotice
    }
  }, [_vm._v(_vm._s(_vm.$t('terms.misc.cancel')))])], 1)])]) : _c('b-button', {
    staticClass: "btn-recomemndation-proceed btn-confirm",
    on: {
      "click": function($event) {
        _vm.updateGoalType(_vm.suggestedGoal.goal_type)
      }
    }
  }, [_vm._v(_vm._s(_vm.$t('pos.campaign-recommendation.proceed')))])], 1), _c('div', {
    staticClass: "mt-2"
  }, [_c('b-button', {
    staticClass: "btn-recommendation-other btn-cancel",
    on: {
      "click": function($event) {
        _vm.toggleSeeOtherOptions()
      }
    }
  }, [_vm._v(_vm._s(_vm.$t('pos.campaign-recommendation.see-other-options')))])], 1)])])]) : (_vm.suggestedGoal) ? _c('div', {
    staticClass: "other-goals"
  }, [_c('h3', [_vm._v(_vm._s(_vm.$t('pos.campaign-recommendation.other-goal-title')))]), _c('div', {
    staticClass: "centered-block lower-list"
  }, _vm._l((_vm.goalTypes), function(goal, key) {
    return _c('div', {
      staticClass: "block-option mt-2 text-center"
    }, [(_vm.displayNotificationFor === key) ? _c('div', {
      staticClass: "box goal-type-notice"
    }, [_c('div', {
      staticClass: "content-box"
    }, [_c('div', {
      staticClass: "text",
      domProps: {
        "innerHTML": _vm._s(_vm.getGoalTypeNotice(key))
      }
    }), _c('div', {
      staticClass: "options"
    }, [_c('b-button', {
      staticClass: "btn-ok",
      attrs: {
        "size": "sm"
      },
      on: {
        "click": function($event) {
          _vm.updateGoalType(key)
        }
      }
    }, [_vm._v(_vm._s(_vm.$t('terms.misc.proceed')))]), _c('b-button', {
      attrs: {
        "variant": "cancel",
        "size": "sm"
      },
      on: {
        "click": _vm.hideGoalTypeNotice
      }
    }, [_vm._v(_vm._s(_vm.$t('terms.misc.cancel')))])], 1)])]) : _c('div', {
      staticClass: "btn btn-recommendation-goal btn-confirm btn-block",
      attrs: {
        "data-goal-type": key
      },
      on: {
        "click": function($event) {
          _vm.updateGoalType(key)
        }
      }
    }, [(goal.label_icon) ? _c('div', {
      staticClass: "goal-type-icon"
    }, [_c('img', {
      attrs: {
        "src": goal.label_icon
      }
    })]) : _vm._e(), _c('span', [_vm._v(_vm._s(_vm.$t(("pos.setup.optimize-for." + key))))])])])
  }))]) : _vm._e()]) : _vm._e()]], 2)], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-0b1c9d70"}!./~/vue-loader/lib/template-compiler/preprocessor.js?raw&engine=pug!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/campaign-recommendation/CampaignRecommendation.vue
// module id = 912
// module chunks = 1